<template>
  <div class="tyy-detail-table">
    <el-dialog
      :visible.sync="tyyDetailTableVisiable"
      :modal="false"
      destroy-on-close
      :width="'90%'"
      :top="'21%'"
      :before-close="closeDialogEvent"
      title="详情"
    >
      <div class="define-table-wrap">
        <div class="defineTable" style="background: #333;">
          <el-table
            :data="chartData"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          >
            <el-table-column
              v-for="(item, index) in columnsData"
              :key="index"
              :prop="item.props"
              :label="item.label"
              :width="item.auto"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    tyyDetailTableVisiable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      chartData: [],
      columnsData: [
        { label: '存货名称',
          props: 'skuname',
          width: '' },
        { label: '期初存货数量',
          props: 'openingNumber',
          width: '' },
        { label: '期初存货金额',
          props: 'openingMoney',
          width: '' },
        { label: '采购数量',
          props: 'poNumber',
          width: '' },
        { label: '采购金额',
          props: 'poMoney',
          width: '' },
        { label: '出库数量',
          props: 'saleoutNumber',
          width: '' },
        { label: '出库金额',
          props: 'saleoutMoney',
          width: '' },
        { label: '实时存货数量',
          props: 'stockNumber',
          width: '' },
        { label: '实时存货金额',
          props: 'stockMoney',
          width: '' },
        { label: '销售数量',
          props: 'saleNumber',
          width: '' },
        { label: '销售金额',
          props: 'saleMoney',
          width: '' }
      ]
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    closeDialogEvent () {
      this.$emit('closeDialogEvent', false)
    },
    longNumberFixed (longFloatNumber) {
      return Number(longFloatNumber.toFixed(2))
    }
  },
  created () {
    const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
    this.$service.fetch({
      url: '/api/global/dashboard_v2/detail',
      params: {
        month: choiceDate.time // '2021-01'
      }
    }).then(res => {
      let tempRes = []
      console.log(res)
      if (res) {
      //   计算每个物料型号的月度综合数据
        for (const key in res?.procectorDetailMap) {
          if (Object.hasOwnProperty.call(res?.procectorDetailMap, key)) {
            const element = res?.procectorDetailMap[key]
            let props = {
              openingMoney: 0,
              skuname: '',
              skucode: '',
              openingNumber: 0,
              poMoney: 0,
              poNumber: 0,
              saleMoney: 0,
              saleNumber: 0,
              saleoutMoney: 0,
              saleoutNumber: 0,
              stockMoney: 0,
              stockNumber: 0
            }
            for (let index = 0; index < element.length; index++) {
              props.id = element[index].skucode
              props.skucode = element[index].skucode
              props.skuname = element[index].skuname
              props.openingMoney = element[0].openingMoney
              props.openingNumber = element[0].openingNumber
              props.poMoney = props.poMoney + element[index].poMoney
              props.poNumber = props.poNumber + element[index].poNumber
              props.saleMoney = props.saleMoney + element[index].saleMoney
              props.saleNumber = props.saleNumber + element[index].saleNumber
              props.saleoutMoney = props.saleoutMoney + element[index].saleoutMoney
              props.saleoutNumber = props.saleoutNumber + element[index].saleoutNumber
              props.stockMoney = index === element.length - 1 ? props.stockMoney + element[element.length - 1].stockMoney : props.stockMoney
              props.stockNumber = index === element.length - 1 ? props.stockNumber + element[element.length - 1].stockNumber : props.stockNumber
            }
            // 给每日数据添加不同的id，用以表格渲染
            element.map(function (item) {
              item.id = item.skucode + item.billdate
              item.skuname = item.billdate
            })
            tempRes.push({
              ...props,
              children: element
            })
          }
        }
        //   计算所有物料的月度综合数据
        let sumProps = {
          id: '',
          openingMoney: 0,
          skuname: '合计',
          skucode: '',
          openingNumber: 0,
          poMoney: 0,
          poNumber: 0,
          saleMoney: 0,
          saleNumber: 0,
          saleoutMoney: 0,
          saleoutNumber: 0,
          stockMoney: 0,
          stockNumber: 0
        }
        for (const iterator of tempRes) {
          sumProps.id = 'sum'
          sumProps.openingMoney = sumProps.openingMoney + iterator.openingMoney
          sumProps.openingNumber = sumProps.openingNumber + iterator.openingNumber
          sumProps.poMoney = sumProps.poMoney + iterator.poMoney
          sumProps.poNumber = sumProps.poNumber + iterator.poNumber
          sumProps.saleMoney = sumProps.saleMoney + iterator.saleMoney
          sumProps.saleNumber = sumProps.saleNumber + iterator.saleNumber
          sumProps.saleoutMoney = sumProps.saleoutMoney + iterator.saleoutMoney
          sumProps.saleoutNumber = sumProps.saleoutNumber + iterator.saleoutNumber
          sumProps.stockMoney = sumProps.stockMoney + iterator.stockMoney
          sumProps.stockNumber = sumProps.stockNumber + iterator.stockNumber
        }
        tempRes.push({
          ...sumProps
        })
        //   对计算结果失去精度的数据进行格式化
        tempRes.forEach(element => {
          element.openingMoney = this.longNumberFixed(element.openingMoney)
          element.poMoney = this.longNumberFixed(element.poMoney)
          element.saleMoney = this.longNumberFixed(element.saleMoney)
          element.stockMoney = this.longNumberFixed(element.stockMoney)
          element.saleoutMoney = this.longNumberFixed(element.saleoutMoney)
        })
      }
      this.chartData = tempRes
    })
  }
}
</script>

<style lang="stylus">
    .define-table-wrap
      padding 10px 0
      .defineTable
        .el-table--border, .el-table--group
          border 1px solid #241f3d
        .el-table--border::after, .el-table--group::after, .el-table::before
          background none
        .el-table th
          background-image linear-gradient(90deg,#005eff,#1896ff)
          color #ffffff
          text-align center
        .el-table tr
          background #1a1533
        .el-table td
          color #a5a5b4
        .el-table td, .el-table th.is-leaf
          border-bottom 1px solid #241f3d
        .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
          border-right 1px solid #241f3d
        .el-table td, .el-table th
          padding 8px 0
        .el-table::before
          background-color #191c21
        .el-table--enable-row-hover .el-table__body tr:hover>td
          background-color #1f1e44
        .el-table--striped .el-table__body tr.el-table__row--striped td
          background #1f1e44
        .el-table__empty-block
          background #201e44
        .el-table--scrollable-x .el-table__body-wrapper
          overflow-x hidden
        .el-table, .el-table__expanded-cell
          background none
        .el-table--scrollable-y .el-table__body-wrapper
          &::-webkit-scrollbar
            width: 0.75rem;
            height: 0.75rem;
            background-color: #F5F5F5;
          &::-webkit-scrollbar-track
            box-shadow: inset 0 0 0.375rem #999;
            border-radius: 0.625rem;
            background-color: #F5F5F5;
          &::-webkit-scrollbar-thumb
            border-radius: 0.625rem;
            box-shadow: inset 0 0 0.375rem #999;
            background-color: #333;
    .define-table-wrap
        padding 0
      .defineTable.isSpaced
        .el-table th,td
          padding 0!important
        .el-table .cell
          line-height initial
    .el-dialog__header
        padding 20px
        .el-dialog__title
            color #fff
    .el-dialog__body
        padding 0 5px
    .el-dialog
        background #1e1e1e
</style>
